export function transposeMatrix(matrix: string[][]): string[][] {
  const rows = matrix.length; 
  const cols = Math.max(...matrix.map((t) => (t.length)));
  const grid = [];
  for (let j = 0; j < cols; j++) {
    grid[j] = Array(rows);
  }
  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
      grid[j][i] = matrix[i][j] ?? '';
    }
  }
  return grid;
}